var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeforeArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 4.34165L9.7786 7.78206L7.66718 9.88277C6.77761 10.7723 6.77761 12.2192 7.66718 13.1088L13.219 18.6606C13.9478 19.3894 15.1911 18.8643 15.1911 17.8461V11.8334V5.1562C15.1911 4.1273 13.9478 3.61284 13.219 4.34165Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeArrowIcon);
export default __webpack_public_path__ + "static/media/beforeArrowIcon.3d732f213ac0d7dddd879a4a29f8c4ec.svg";
export { ForwardRef as ReactComponent };